import { render, staticRenderFns } from "./ModalLeadsMsgVSA.vue?vue&type=template&id=36f89385&"
import script from "./ModalLeadsMsgVSA.vue?vue&type=script&lang=js&"
export * from "./ModalLeadsMsgVSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports